export default "/fonts/vendor/summernote/dist/summernote.woff2?f19578aed7aa19113900304c6bec7448";